import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "react-query";
import { SWRConfig, SWRConfiguration } from "swr";

import ToastProvider from "./Context/ToastContext/ToastContext";
import { ToastContainer } from "./Components/StyledComponents/Toast";
import { getHomeRoutes } from "./pages/Home/Home";
import { AutherRoutes } from "./pages/AutherRoutes";
import CompleteAuth from "./pages/CompleteAuth";



import "./App.css";


/** @type { SWRConfiguration } */
const swrConfiguration = {
  // prevent unnecessary API calls
  dedupingInterval: 5 * 60 * 1000,  // 5 minutes: avoid new requests for the same key
  revalidateOnFocus: false,         // do not revalidate on window focus
  revalidateOnReconnect: false,     // do not revalidate when reconnecting
  revalidateIfStale: false,         // do not revalidate even if stale
  refreshInterval: 0,               // no polling

  // error handling - limit retries to avoid excessive calls
  errorRetryCount: 2,
  errorRetryInterval: 2000,

  // keep previous data while fetching new data
  keepPreviousData: true,

  // window focus revalidation throttle
  focusThrottleInterval: 60 * 1000,
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SWRConfig value={swrConfiguration}>
          <BrowserRouter>
            <ToastProvider>
              <ToastContainer />
              <Routes>
                <Route path="complete-auth" element={<CompleteAuth />} />
                <Route element={<AutherRoutes />}>
                  {getHomeRoutes()}
                </Route>
              </Routes>
            </ToastProvider>
          </BrowserRouter>
        </SWRConfig>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
